import React, { useEffect, useState } from "react";
import Modal from "../ components/Modal";
import SectionFour from "../ components/SectionFour";
import LastSection from "../ components/LastSection";
import SectionThree from "../ components/SectionThree";
import SectionTwo from "../ components/SectionTwo";
import SectionFive from "../ components/SectionFive";
import "@fontsource/roboto"; // Defaults to weight 400
import SectionOne from "../ components/SectionOne";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

function Home() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // State for preloader
  const navigate = useNavigate();
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const navigateFunc = () => {
    navigate("/thank-you");
  }

  // Simulate loading delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Hide preloader after 2 seconds
    }, 2000);
    return () => clearTimeout(timer);
  }, [isLoading]);

  return (
    <div className="App relative font-poppins bg-white">
      {/* Preloader */}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
          <div className="w-16 h-16 border-4 border-[#3E88FF] border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {/* Toaster for displaying toast notifications */}
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 3000,
          style: {
            background: "#fff",
            color: "#363636",
          },
        }}
      />
      {/* Main Content */}
      {!isLoading && (
        <>
          <div className="w-full">
            <SectionOne openModal={openModal} />
            <SectionTwo openModal={openModal} />
            <SectionThree openModal={openModal} />
            <SectionFour openModal={openModal} />
            <SectionFive />
            <LastSection openModal={openModal} />
            <Modal
              isOpen={isModalOpen}
              onClose={closeModal}
            />
          </div>

          <div
            className="fixed right-0 top-1/3 z-50 bg-[#E91212] text-white font-bold text-xs xl:text-base
        rounded-l-full cursor-pointer shadow-lg transition-all duration-300 hover:scale-105 w-10 xl:w-16
        hover:w-20 py-10 xl:py-16 hover:py-2 xl:hover:py-4 flex items-center justify-center min-h-[80px] xl:min-h-[100px] hover:min-h-[100px] xl:hover:min-h-[120px]"
            onClick={openModal}
          >
            <span className="rotate-90 whitespace-nowrap">Contact Us</span>
          </div>
        </>
      )}
    </div>
  );
}

export default Home;
